import home1 from "../../assets/img/IMG-20251108-WA0069.jpg";
import { Link } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
const ourService = [
  { id: 1, name: "Landscape Design", url: "landscape-design" },
  { id: 2, name: "Hardscape", url: "hardscape" },
  { id: 3, name: "Landscape Lighting", url: "landscape-lighting" },
  { id: 4, name: "Softscape", url: "softscape" },
  { id: 5, name: "Plantation", url: "plantation" },
  { id: 6, name: "Replanting", url: "replanting" },
  {
    id: 7,
    name: "Lawn Development and Maintenance",
    url: "lawn-development-and-maintenance",
  },
  {
    id: 8,
    name: "Horticultural Maintenance",
    url: "horticultural-maintenance",
  },
  {
    id: 9,
    name: "Vertical & Terrace Garden",
    url: "vertical-and-terrace-garden",
  },
  { id: 10, name: "Irrigation System", url: "irrigation-system" },
];
function Plantation() {
  return (
    <>
      <section className="serviceList sectionPD">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="aboutImg">
                <img src={home1} alt="About" className="img-fluid" />
              </div>
              <div className="blogCategory mt-4">
                <ul>
                  {ourService.map((item) => {
                    return (
                      <li key={item.id}>
                        <Link to={`${item.url}`}>
                          <FiChevronRight />
                          {item.name}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="fisherman-content">
                <h6>The Foundation of Every Lush, Living Landscape</h6>
                <h3>🌳 Plantation</h3>
                <p>
                  Plantation is more than just placing plants in the ground —
                  it’s about giving life to a space in a way that feels natural
                  and lasting. Every tree, shrub, or flower you plant is a step
                  toward creating an environment that breathes, grows, and
                  changes with time.
                </p>
                <p>
                  Good plantation starts with understanding the soil, sunlight,
                  and climate of the area. The right plant in the right place
                  not only thrives but also enhances the beauty and
                  functionality of the space. Whether it’s a small terrace
                  garden, a courtyard, or a sprawling landscape, thoughtful
                  plantation can transform it from empty land into a living,
                  vibrant environment.
                </p>
                <p>
                  Authentic plantation work considers both aesthetics and
                  ecology. Native plants are a natural choice — they need less
                  care, attract local birds and butterflies, and create a
                  sustainable ecosystem. Seasonal flowering plants, shade trees,
                  and medicinal herbs together make a plantation feel alive and
                  purposeful.
                </p>
                <p>
                  The key to real plantation is patience. Plants grow slowly,
                  and their beauty unfolds over time. But with proper planning,
                  care, and selection, a well-planned plantation not only
                  beautifies a space but also brings a sense of peace, balance,
                  and connection with nature.
                </p>
              </div>

             
              <div className="fisherman-content">
                <h5>🌿 Ready to Green Your Space?</h5>
                <p>
                  Our expert horticulture and landscaping team helps design and
                  plant vibrant, healthy environments — tailored to your space,
                  climate, and vision. Whether it’s a full garden overhaul or a
                  small green addition, we’ll ensure your plantation thrives for
                  seasons to come.
                </p>
                <a className="commonButton mt-3" href="mailto:info@example.com">
                  📧 Contact Us Today
                </a>
              </div>
            </div>
          </div>

          <div className="fisherman-content d-none">
            <h4>🌸 Key Factors in a Successful Plantation Plan</h4>
            <ul>
              <li>
                🌱 <strong>Soil health and preparation</strong>
              </li>
              <li>
                ☀️ <strong>Sunlight and water availability</strong>
              </li>
              <li>
                🧪 <strong>Plant compatibility (climate, region)</strong>
              </li>
              <li>
                🎨 <strong>Aesthetic layout and plant layering</strong>
              </li>
              <li>
                🛠️ <strong>Maintenance needs and growth patterns</strong>
              </li>
            </ul>
          </div>
          <div className="fisherman-content d-none">
            <h4>🛠️ Our Plantation Services Include:</h4>
            <ul>
              <li>Site analysis and soil testing</li>
              <li>Custom plant selection and sourcing</li>
              <li>Seasonal planting plans</li>
              <li>Tree and shrub installation</li>
              <li>Flower bed design and planting</li>
              <li>Lawn seeding or turf laying</li>
              <li>Container and vertical garden plantation</li>
              <li>Maintenance support (watering, pruning, fertilization)</li>
            </ul>
          </div>
          <div className="fisherman-content d-none">
            <h4>🌿 Why Plantation Matters</h4>
            <ul>
              <li>
                <strong>Brings Nature Closer</strong> – Softens built
                environments and reconnects people with nature
              </li>
              <li>
                <strong>Improves Air Quality</strong> – Plants absorb CO₂ and
                release oxygen
              </li>
              <li>
                <strong>Reduces Heat</strong> – Trees provide natural cooling
                and shade
              </li>
              <li>
                <strong>Boosts Mood</strong> – Green spaces have been shown to
                reduce stress and anxiety
              </li>
              <li>
                <strong>Enhances Biodiversity</strong> – Supports bees,
                butterflies, birds, and other wildlife
              </li>
              <li>
                <strong>Improves Property Value</strong> – A green, healthy
                landscape adds curb appeal and resale value
              </li>
            </ul>
          </div>
           <div className="fisherman-content">
                <h4>Types of Plantation in Landscaping</h4>
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Category</th>
                      <th>Examples</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Trees</td>
                      <td>Shade trees, ornamental, fruit trees</td>
                    </tr>
                    <tr>
                      <td>Shrubs</td>
                      <td>Hedges, flowering, evergreen shrubs</td>
                    </tr>
                    <tr>
                      <td>Flowering Plants</td>
                      <td>Annuals, perennials, native blooms</td>
                    </tr>
                    <tr>
                      <td>Groundcovers</td>
                      <td>Grass, moss, creepers</td>
                    </tr>
                    <tr>
                      <td>Climbers/Vines</td>
                      <td>Bougainvillea, ivy, jasmine</td>
                    </tr>
                    <tr>
                      <td>Container Plants</td>
                      <td>Planters for patios, balconies</td>
                    </tr>
                  </tbody>
                </table>
              </div>
        </div>
      </section>
    </>
  );
}

export default Plantation;
